import React from 'react';
import { IconProps } from '.';

const SvgLock = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M15 16.25H9v-1.5h6v1.5Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M7.25 8.5H3v14h18v-14h-4.25V5.37C16.75 2.795 14.6.75 12 .75S7.25 2.795 7.25 5.37V8.5Zm1.5-3.13c0-1.7 1.431-3.12 3.25-3.12s3.25 1.42 3.25 3.12V8.5h-6.5V5.37ZM19.5 21V10h-15v11h15Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgLock;
